// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;Set a watch before my mouth, O Lord,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and guard the door of my lips;<br> </p> </div></div>";
// Exports
module.exports = code;